import Icon from '../components/Icon.vue'

Icon.register({
  registered: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M285.4 207.5c0 18.6-9.8 28.4-28.4 28.4h-29.9v-56.1h23.4c28.7 0 34.9 8.8 34.9 27.7zM504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM363.4 360.4c-46.7-84.8-43.3-78.6-44.7-81 23.4-15.2 37.9-43 37.9-74.5 0-54.2-31.5-89.3-105.5-89.3h-70.7c-13.3 0-24 10.7-24 24v232.3c0 13.3 10.7 24 24 24h22.6c13.3 0 24-10.7 24-24v-71.7h25.6l44.1 82.9c3.7 7 13.2 12.7 21.2 12.7h24.5c18.3 0 29.8-19.6 21-35.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/registered.js
// module id = 1683
// module chunks = 0